import { NotificationHelper } from "../../core/util/notificationHelper";
import { AppHelper } from "../../appHelper";
import { AppBaseProps, CommonApp, Context, Entity } from "../../core/components/commonApp";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { Helper } from "../../core/util/helper";
import React from "react";
export default class CashExpense extends React.Component<CashExpenseProps, any>{
    common = new AppHelper();
    languageSpezificGridOptions = [];

    constructor(props) {
        super(props);
        this.common.init(this);
    }

    componentDidMount() {
        this._setEvents();
        this.props.context.languageSpezificGridOptions = this._getMetaData("languageSpezificGridOptions");
        this.setState({});
    }

    private _getMetaData = (name: string) => {
        const objects = this.props.metadata.additional.objects;
        for (let i = 0; i < objects.length; i++) {
            if (objects[i].name == name) {
                return objects[i].data;
            }
        }
    }

    save = async (closeAfterSave) => {
        if (this.isValide(this.props.entity)) {
            var result = await HTTPService.post<JsonResultClass>("GeneralSettingsCashExpenses/Save", this.props.entity)
            if (result.Code === 0) {
                this.props.entity.IsNew = false;
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, closeAfterSave);
            this.setState({});
        }
        else {
            NotificationHelper.showErrorMessage(Helper.getTranslation("Standard.PflichtfeldAllgemein") + "/n" + Helper.getTranslation("WebSMS.GeneralSettings.CashExpenses.AtLeastOneLanguage"));
        }
    }

    isValide = (entity: Baraus) => {
        let isValid = Helper.hasValue(entity.Nr);
        if (entity.IsNewIdBaraus) {
            isValid = entity.IdBaraus > 0;
        }
        return isValid && this.checkNames(entity);
    }

    private checkNames = (entity: Baraus) => {
        let isValid = Helper.hasValue(entity.OriginalDescription);
        for (let i = 0; i < entity.Translations.length; i++) {
            if (isValid)
                return true;
            isValid = Helper.hasValue(entity.Translations[i].TemplateName);
        }
        return isValid;
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.OriginalDescription":
                let sheet = General.Sheet.Manager.getTopMostSheet();
                sheet.trigger(SheetEventType.Custom, { command: "cashExpenseTemplateNameChanged", value: value });
                break;
            case "entity.Unit":
                break;
        }

        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
        }
    }


    private _setEvents = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (cus: { command: string, value: any }) => {
            if (cus.command === "cashExpenseLanguageSpezificValueChanged") {
                this.common.setEntityDirtyState(true);
            }
        });
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface CashExpenseProps extends AppBaseProps {
    entity: Baraus;
    context: CashExpenseContext;
}

export interface CashExpenseContext extends Context {
    translations?: {};
    languageSpezificGridOptions?: any;
}


export interface Baraus extends Entity {
    Nr?: number;
    IdBaraus?: number;
    IsGuid?: string;
    OriginalDescription?: string;
    Description?: string;
    ExpenseType?: string;
    CurrencyId?: string;
    UnitId?: string;
    Unit?: string;
    Amount?: number;
    Quantity?: number;
    CostFactor?: number;
    InvoiceFactor?: number;
    ExpensesAmount?: number;
    InvoiceAmount?: number;
    ZeroAmount?: number;
    IsPriceLocked?: boolean;
    IsQuantityLocked?: boolean;
    IsPriceLockedAdmin?: boolean;
    IsQuantityLockedAdmin?: boolean;
    IsPriceLockedInvoice?: boolean;
    IsQuantityLockedInvoice?: boolean;
    IsNewIdBaraus?: boolean;
    LockAmount?: boolean;
    LockQuantity?: boolean;
    Deleted?: boolean;
    Translations?: any[];
}